import React, { useState } from 'react';
import './Hero.css';

export default function AboutHero({ background = "/Amoda_sari_hero.webp" }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen((v) => !v);

  return (
    <section className="hero">
      <div className="hero-image" style={{ backgroundImage: `url('${background}')` }} />
      <div className="hero-overlay"></div>

      <nav className="hero-nav">
        <div className="hero-logo">
          <img src="/glob_stay_logo.png" alt="Glob Stay Logo" className="logo-image" />
        </div>

        <div
          className="hamburger"
          onClick={toggleMenu}
          role="button"
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMenu(); } }}
        >
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
        </div>

        <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
          <a href="/" className="mobile-nav-link" onClick={toggleMenu}>Home</a>
          <a href="#" className="mobile-nav-link" onClick={toggleMenu}>Book a stay</a>
          <a href="#values" className="mobile-nav-link" onClick={toggleMenu}>Values</a>
          <a href="#visit" className="mobile-nav-link" onClick={toggleMenu}>Visit</a>
        </div>
      </nav>

      <div className="hero-content">
        <p className="hero-tagline">Luxury Rooted in Serenity.</p>
        <h1 className="hero-title">AMODA SARI</h1>
      </div>

    </section>
  );
}


